import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Button, Icon } from 'loyal-react'
import { Link } from 'react-router-dom'
import { Title, ProductShipping, TrackingItem } from './'

import { ProductImage } from 'features/ProductImage'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'
import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'

import 'react-placeholder/lib/reactPlaceholder.css'

import ReactPlaceholder from 'react-placeholder'
import TrackingItemPlaceholder from './TrackingItemPlaceholder'

const voucherName = 'DSHOP'

const getVoucherLink = props => {
  let model = {
    OrderId: props.orderDetail.orderId,
    CatalogId: props.orderDetail.catalogId,
    VendorId: props.orderDetail.vendorId,
    ClientId: props.orderDetail.clientId
  }
  props.handleVoucherLink(model)
}

const veryfyCustomMessage = (props) => {
  const vendorName = props.parentOrderDetail.vendorOrderModel[0].vendorName
  const vendorType = props.orderDetail.vendorType

  switch (vendorType) {
    case 'Milhas':
      return `Transferência de pontos para ${vendorName}`

    default:
      return props.productDetail.name
  }
}

const ProductSide = props => {
  const [apiVendors, setApiVendors] = React.useState([])
  const { vendors } = props.availableVendors

  React.useEffect(() => {
    setApiVendors(vendors)
  }, [vendors])

  let decimalValue =
    props &&
    props.parentOrderDetail &&
    props.parentOrderDetail.orderPaymentDetailMoneyAndPoints &&
    props.parentOrderDetail.orderPaymentDetailMoneyAndPoints
      .purchaseValueDecimal
  let pointsUsedDecimal =
    props.parentOrderDetail.orderPaymentDetailMoneyAndPoints &&
    props.parentOrderDetail.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal

  let storeDescription =
    props.storeConfiguration &&
    props.storeConfiguration.description &&
    props.storeConfiguration.description.toUpperCase()
  let storeName = (props.parentOrderDetail && props.parentOrderDetail.vendorOrderModel && props.parentOrderDetail.vendorOrderModel[0] && props.parentOrderDetail.vendorOrderModel[0].vendorName && props.parentOrderDetail.vendorOrderModel[0].vendorName.toUpperCase()) || ''
  let unitValue = null

  let donationValue = props &&
  props.productDetail &&
  props.productDetail.currencySellingPrice

  if (
    props.parentOrderDetail.vendorOrderModel[0].vendorName ===
    'Compra de Pontos'
  ) {
    unitValue = (
      <div className='col-12 txt-body-sm txt-font-body color-ui-2'>
        Valor: <strong>R$ {addZeroes(decimalValue)}</strong>
      </div>
    )
  } else if (props.parentOrderDetail.paymentType === 5) {
    const valueLabel = `Valor unitário: R$ ${addZeroes(decimalValue)}`
    unitValue = (
      <div className='col-12 txt-body-sm txt-font-body color-ui-2'>
        {valueLabel}
      </div>
    )
  } else if (props.orderDetail.vendorType === 'Doação') {
    unitValue = (
      <div className='col-12 txt-body-sm txt-font-body color-ui-2'>

        <CatalogCurrencyLabel
          prefix={'Valor em pontos: '}
          value={
            pointsUsedDecimal !== props.productDetail.sellingPrice &&
              pointsUsedDecimal !== 0
              ? pointsUsedDecimal
              : props.productDetail.sellingPrice
          }
        />
        {props && props.productDetail && props.productDetail.currencySellingPrice
          ? <p className='txt-body-sm txt-font-body color-ui-2 txt-initial'>Valor: R$ {addZeroes(donationValue)}</p>
          : ''}
      </div>
    )
  } else {
    const valueLabel = `Valor${(props.orderDetail.vendorType !== 'Milhas') && ' unitário'} : `
    unitValue = (
      <div className='col-12 txt-body-sm txt-font-body color-ui-2'>
        <CatalogCurrencyLabel
          prefix={valueLabel}
          value={
            pointsUsedDecimal !== props.productDetail.sellingPrice &&
            pointsUsedDecimal !== 0
              ? pointsUsedDecimal
              : props.productDetail.sellingPrice
          }
        />
        {props.parentOrderDetail.orderPaymentDetailMoneyAndPoints
          .purchaseValueDecimal !== 0 &&
        props.parentOrderDetail.paymentType === 2
          ? ` + R$ ${addZeroes(
            props.parentOrderDetail.orderPaymentDetailMoneyAndPoints
              .purchaseValueDecimal
          )}`
          : ''}
      </div>
    )
  }

  const quantityLabel = `Quantidade: ${props.productDetail.quantity}`
  const shippingLabel = `Previsão de entrega: ${moment
    .utc(props.productDetail.deliveryForecastParticipant)
    .format('DD/MM/YYYY')}`
  const productImage = props.orderDetail.vendorId === 92249 ? 'https://blbltmlive001.blob.core.windows.net/supplier/Liveb29a0d33-3c39-428d-bc1f-1700ba225157.jpg' : props.productDetail.imageUrl

  const handleBarCode = useMemo(() => props.productDetail.itemConfiguration && props.productDetail.itemConfiguration.filter(item => item.key === 'BarCode')[0], [props.productDetail.itemConfiguration])
  const handleDueDate = useMemo(() => props.productDetail.itemConfiguration && props.productDetail.itemConfiguration.filter(item => item.key === 'DueDate')[0], [props.productDetail.itemConfiguration])

  const handleDocument = () => {
    let html = document.createElement('div')
    const date = props.orderDetail.dateStatus
    const costPrice = props.productDetail.costPrice

    html.innerHTML = `
        <div class='container py-3'>
          <div>
            <div class='col-12 text-center py-4'>COMPROVANTE DE PAGAMENTO</div>
            <div class='py-3'>
              <div class='d-flex col-12'>
                <span class='col-4'>Código de Barras: </span>
                <div class='col-8'>${handleBarCode && handleBarCode.value}</div>
              </div>
              <div class='d-flex col-12'>
                <span class='col-4'>Data de Pagamento: </span>
                <div class='col-8'>${moment(date).format('L')}</div>
              </div>
              <div class='d-flex col-12'>
                <span class='col-4'>Data de Vencimento: </span>
                <div class='col-8'>${handleDueDate && handleDueDate.value}</div>
              </div>
              <div class='d-flex col-12'>
                <span class='col-4'>Valor:</span>
                <div class='col-8'>R$ ${numberToStrCurrency(costPrice)}</div>
              </div>
              <div class='d-flex col-12'>
                <span class='col-4'>Assinatura: </span>
                <div class='col-8 text-break'>${props.formatedSignature}</div>
              </div>
            </div>
            <div>
              <p>Pagamento efetuado com base nas informações do código de barras.</p>
              <p>Guarde este recibo junto com o documento original para eventual comprovação do pagamento</p>
            </div>
          </div>
        </div>
      `

    const documentContainer = document.getElementById('document')

    if (documentContainer) {
      documentContainer.innerHTML = ''

      documentContainer.appendChild(html)

      var mywindow = window.open('', 'PRINT', 'height=400,width=600')

      mywindow.document.write('<html><head><link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-eOJMYsd53ii+scO/bJGFsiCZc+5NDVN2yr8+0RDqr0Ql0h+rP48ckxlpbzKgwra6" crossorigin="anonymous" /><title>' + document.title + '</title>')
      mywindow.document.write('</head><body >')
      mywindow.document.write(documentContainer.innerHTML)
      mywindow.document.write('</body></html>')

      mywindow.document.close() // necessary for IE >= 10
      mywindow.focus() // necessary for IE >= 10*/

      mywindow.print()
    }
  }

  const enableReceipt = (props.parentOrderDetail && props.parentOrderDetail.configurationModels) &&
  props.parentOrderDetail.configurationModels.find(obj => obj.key === 'Receipt')

  return (
    <div className='cart-side col-12 col-md-8 px-0 pl-md-1 pr-md-2'>
      <div className='border-ui-3 radius bg-white'>
        <Title orderId={props.parentOrderDetail.parentOrderId} />
        <div className='cart-products col-12 mx-0'>
          <div className='cart-item row px-2 border-color-ui-3 border-bottom py-2'>
            <div className='cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'>
              <ProductImage
                name={props.productDetail.name}
                alt={props.productDetail.name}
                imageUrl={productImage}
                vendorId={props.orderDetail.vendorId}
                vendorType={props.orderDetail.vendorType}
                ready
                ariaHidden
              />
            </div>
            <div className='cart-product-info col'>
              <div className='cart-product-info row'>
                <div className='product-infos col-12 mx-0'>
                  <p className='txt-body-sm txt-font-body color-ui-2 '>
                    {veryfyCustomMessage(props)}
                  </p>
                </div>
              </div>
              <div className='row card-price-item  mt-1'>
                <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                  {props.orderDetail.vendorType === 'Compra de Pontos' ? (
                    <span className='d-block'>
                      <CatalogCurrencyLabel
                        prefix='Quantidade: '
                        value={props.productDetail.quantity * props.packageSize}
                      />
                    </span>
                  ) : (
                    props.orderDetail.vendorType !== 'Milhas' &&
                    props.orderDetail.vendorType !== 'Doação' &&
                    props.orderDetail.vendorType !== 'Pague Contas'
                  ) && (
                    <span className='price-value'>
                      {quantityLabel}
                    </span>
                  )}
                </div>

                {unitValue}

                {props.orderDetail.vendorType === 'Pague Contas' && (
                  <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                    <div>
                      Boleto: {handleBarCode && handleBarCode.value}
                    </div>
                    <div>
                      Realizado em: {handleDueDate && handleDueDate.value}
                    </div>
                  </div>
                )}

                {props.productDetail.deliveryForecastParticipant && props.orderDetail.vendorType !== 'Voucher Virtual Externo' ? (
                  <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                    {shippingLabel}
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>

            {props.orderDetail.vendorType === 'Pague Contas' && enableReceipt && (
              <div className='col'>
                <button role='button' onClick={handleDocument}>Ver comprovante</button>
                <div id='document' className='hide-absolute' />
              </div>
            )}
          </div>
        </div>
        {props.orderDetail.trackingVtexData ? (
          <div
            className={`row mx-0 px-3 border-color-ui-3 border-bottom py-2 d-print-none ${
              !props.productDetail.tracking ? 'd-none' : ''
            } `}
          >
            <ProductShipping
              trackingVtexData={props.orderDetail.trackingVtexData}
            />
          </div>
        ) : apiVendors.length && apiVendors.includes(props.orderDetail.vendorId) &&
          props.tracking ? (
          // eslint-disable-next-line react/jsx-indent
            <div
              className={`row mx-0 px-3 border-color-ui-3 border-bottom py-2 ${
                !props.productDetail.tracking ? 'd-none' : ''
              } `}
            >
              <ReactPlaceholder
                ready={!!props.tracking}
                customPlaceholder={<TrackingItemPlaceholder />}
              >
                <div className='row py-1 px-0'>
                  <TrackingItem tracking={props.tracking} />
                </div>
              </ReactPlaceholder>
            </div>
          ) : props.orderDetail.vendorType === 'e-Commerce' ? (
            <div className={`row mx-0 px-3 border-color-ui-3 border-bottom py-2`}>
              <ReactPlaceholder
                ready={props.showPlaceholder}
                customPlaceholder={<TrackingItemPlaceholder />}
              >
                <div className='row py-1 px-0'>
                  <TrackingItem
                    tracking={
                      props.orderDetail.vendorType === 'e-Commerce' &&
                    props.orderDetail.items.length > 0 &&
                    props.trackingAlternative
                    }
                  />
                </div>
              </ReactPlaceholder>
            </div>
          ) : (
            ''
          )}
        <div className='row mx-0 px-0 border-color-ui-3 border-bottom'>
          {storeName.includes(voucherName) ||
          (storeDescription && storeDescription.includes(voucherName)) ? (
            // eslint-disable-next-line react/jsx-indent
              <div className='row col-12 mx-0 px-3 bg-ui-5 border-color-ui-3 border-top border-bottom py-2'>
                <div className='row mx-0 col-12 col-md-9 align-items-center'>
                  <p className='txt-body-sm'>
                    <strong>
                      Consulte para saber mais sobre o envio do seu cupom.
                    </strong>
                  </p>
                </div>
                <div className='row mx-0 col-12 col-md-3'>
                  <Button
                    className='btn btn-featured btn-cart'
                    text='Consultar'
                    onClick={() => getVoucherLink(props)}
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          <div className='d-none d-md-block row col-12 py-1 px-2 d-print-none'>
            <div className='cart-back px-0 txt-left'>
              <Link aria-label='Ver todos os pedidos' to={props.previousRoute || '/my-orders/'} className='btn btn-sm btn-flat btn-icon txt-left'>
                <Icon
                  iconName='icon_left'
                  className='icon icon-smr'
                  aria-hidden
                />
                <span aria-hidden>Ver todos os pedidos</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function addZeroes (value) {
  let newValue = value * 1
  newValue = newValue + ''

  let pos = newValue.indexOf('.')
  if (pos === -1) newValue = newValue + '.00'
  else {
    var integer = newValue.substring(0, pos)
    var decimals = newValue.substring(pos + 1)
    while (decimals.length < 2) decimals = decimals + '0'
    newValue = integer + ',' + decimals
  }
  return newValue.toString().replace('.', ',')
}

const mapStateToProps = ({ availableVendors }) => ({ availableVendors })

ProductSide.propTypes = {
  productDetail: PropTypes.object,
  parentOrderDetail: PropTypes.object,
  orderDetail: PropTypes.object,
  previousRoute: PropTypes.string,
  tracking: PropTypes.object,
  showPlaceholder: PropTypes.bool,
  storeConfiguration: PropTypes.object,
  trackingAlternative: PropTypes.object,
  packageSize: PropTypes.number,
  availableVendors: PropTypes.object,
  formatedSignature: PropTypes.string
}

export default connect(mapStateToProps, null)(ProductSide)



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/ProductSide.js